export default function search(){
    $("#search").on('search', function () {
        window.location = $(this).attr('url') + '?search=' + $(this).val();
    });

    $("#search").on('keypress', function (e) {
        if (e.key === "Enter") {
            window.location = $(this).attr('url') + '?search=' + $(this).val();
        }
    });
    $("#buscar").on('click', function(){
        window.location = $(this).attr('url') + '?search=' + $(this).val();
    });

    // Create a media query that matches mobile devices
    const mobileQuery = window.matchMedia('(max-width: 990px)');

    // Check if the media query matches
    if (mobileQuery.matches) {
        const searchIcon = document.querySelector('.search-mobile img');
        const closeIcon = document.querySelector('.search-mobile i');
        if (searchIcon) {
            searchIcon.addEventListener('click', (() => {
                document.querySelector('.search-mobile').classList.add('active');
                gsap.to('.search__box',{
                    display:'block'
                })
            }))
        }
        if (closeIcon) {
            closeIcon.addEventListener('click', (() => {
                gsap.to('.search__box',{
                    display:'none'
                })
                document.querySelector('.search-mobile').classList.remove('active');
            }));
        }
    } else {
        var tl = gsap.timeline({
            paused: true
        });
        tl.to('.search-input', {
            display: 'block'
        })
        tl.to('.search-input', {
            width: '95%'
        }, '<')

        const searchIcon = document.querySelector('.icon-search img');
        const closeIcon = document.querySelector('.icon-search i');

        if (searchIcon) {
            searchIcon.addEventListener('click', (() => {
                tl.play()
                document.querySelector('.icon-search').classList.add('active');
            }));
        }
        if (closeIcon) {
            closeIcon.addEventListener('click', (() => {
                console.log('click')
                tl.reverse()
                document.querySelector('.icon-search').classList.remove('active');
            }))
        }

    }


}
